import { render } from "./CategoryAndDishesComponent.vue?vue&type=template&id=013c0509&scoped=true"
import script from "./CategoryAndDishesComponent.vue?vue&type=script&lang=js"
export * from "./CategoryAndDishesComponent.vue?vue&type=script&lang=js"

import "./CategoryAndDishesComponent.vue?vue&type=style&index=0&id=013c0509&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013c0509"]])

export default __exports__